import React, { useEffect } from "react";
import ProjectDescription from '../components/ProjectDescription';
import { Helmet } from "react-helmet";
import { Container, Row, Col } from 'react-grid-system';
import  ProjectModel from '../models/ProjectModel';
import ProjectIndex from '../components/ProjectIndex';
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import '../App.css';

function AdidasStateSneakers({dispatch}) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  return (
  <div className="wrapper">

	<Helmet>
		<meta charSet="utf-8" />
		<title>Maria Chimishkyan — {ProjectModel.AdidasStateSneakers.title}</title>
	</Helmet>

	<div className="inner-wrapper">

	<Container fluid className="page-pad">
		<Row>
			<Col sm={3}>
				<div className="description-sticky">
				  <ProjectDescription projectModel={ProjectModel.AdidasStateSneakers}/>
				</div>
			</Col>
			<Col sm={6}>
				<div className="cs-half-images">
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-1-Ultraboost-1.0.jpg" alt="Adidas - State Sneakers — Ultraboost 1.0" style={{ width: '100%' }}/>
						<div className="project-caption">Ultraboost 1.0</div>
					</div>
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-2-NMD-R1.jpg" alt="Adidas - State Sneakers — NMD R1" style={{ width: '100%' }}/>
						<div className="project-caption">NMD R1</div>
					</div>
				</div>
				<div className="cs-section-sep">
				<div className="cs-half-images">
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-3-Samba.jpg" alt="Adidas - State Sneakers — Samba" style={{ width: '100%' }}/>
						<div className="project-caption">Samba</div>
					</div>
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-4-Superstar.jpg" alt="Adidas - State Sneakers — Superstar" style={{ width: '100%' }}/>
						<div className="project-caption">Superstar</div>
					</div>
				</div>
				</div>
				<div className="cs-section-sep">
				<div className="cs-half-images">
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-5-Mahomes-1-Impact-FLX-1.jpg" alt="Adidas - State Sneakers — Mahomes 1 Impact FLX 1" style={{ width: '100%' }}/>
						<div className="project-caption">Mahomes 1 Impact FLX 1</div>
					</div>
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-6-Adilette-Comfort.jpg" alt="Adidas - State Sneakers — Adilette Comfort" style={{ width: '100%' }}/>
						<div className="project-caption">Adilette Comfort</div>
					</div>
				</div>
				</div>
				<div className="cs-section-sep">
				<div className="cs-half-images">
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-7-Swift-Run.jpg" alt="Adidas - State Sneakers — Swift Run" style={{ width: '100%' }}/>
						<div className="project-caption">Swift Run</div>
					</div>
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-8-Crazy-Flight.jpg" alt="Adidas - State Sneakers — Crazy Flight" style={{ width: '100%' }}/>
						<div className="project-caption">Crazy Flight</div>
					</div>
				</div>
				</div>
				<div className="cs-section-sep">
				<div className="cs-half-images">
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-9-Nova-Flight.jpg" alt="Adidas - State Sneakers — Nova Flight" style={{ width: '100%' }}/>
						<div className="project-caption">Nova Flight</div>
					</div>
					<div>
						<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-10-Terrex-Free-Hiker.jpg" alt="Adidas - State Sneakers — Terrex Free Hiker" style={{ width: '100%' }}/>
						<div className="project-caption">Terrex Free Hiker</div>
					</div>
				</div>
				</div>
				<div className="cs-section-sep">
					<img src="img/project-page/adidas-statesneakers/adidas-MariaChimishkyan-11-Ultraboost-22.jpg" alt="Adidas - State Sneakers — Ultraboost 22" style={{ width: '100%' }}/>
					<div className="project-caption">Ultraboost 22</div>
				</div>
			</Col>
		</Row>
	</Container>

	</div>
	<ProjectIndex/>
</div>

  )
}

export default connect()(AdidasStateSneakers);
